import classNames from "../classNames";

function noop() {}

const defaultProps = {
  positiveButton: "YES",
  negativeButton: "CANCEL",
  onPositiveClick: noop,
  onNegativeClick: noop,
  type: "danger",
  icon: "bi bi-check-circle",
};

function ConfirmDialog({ title, message, icon, type }) {
  return (
    <div className="p-4 pb-0 d-flex flex-column">
      <div className="d-flex gap-2">
        <div
          style={{ backgroundColor: "#F5F5F5" }}
          className="h-50 p-1 rounded-3"
        >
          <i
            className={classNames(icon) + " rounded p-3"}
            style={{ fontSize: "1.7rem", color: "#d18237" }}
          ></i>
        </div>
        <div className="d-flex flex-column gap-3 mt-2">
          <h4 className="fw-bold" style={{ color: "#d18237" }}>
            {title}
          </h4>
          <p className="m-0 fw-light">{message}</p>
        </div>
      </div>
    </div>
  );
}

ConfirmDialog.defaultProps = defaultProps;
export default ConfirmDialog;
